import { parseOrRaw } from 'domain/shared/validation'
import { googleAudiencesResponseSchema } from './schemas'

// parseOrRaw falls through to the raw response on schema mismatch rather than
// breaking the selector.
export function mapGoogleAudiencesResponse(data) {
  const parsed = parseOrRaw(googleAudiencesResponseSchema, data)
  const items = Array.isArray(parsed) ? parsed : []

  return items.map((item) => ({
    id: item.id,
    resource_name: item.resource_name,
    name: item.name,
    type: item.type ?? null,
    audience_type: item.audience_type,
    size_for_display: item.size_for_display ?? null,
  }))
}

// GOOGLE_TC_TARGETING_SCHEMA.audience_resource_names (DEMAND_GEN-only) wants
// bare resource-name strings, not the rich {resource_name, id, name, ...}
// shape audiences/excluded_audiences use — flatten type=saved results here
// rather than at every call site.
export function toAudienceResourceNames(items) {
  return items.map((item) => item.resource_name).filter(Boolean)
}
